
const shimmerKeyframes = `
@keyframes shimmer {
  0% { background-position: 100% 100%; }
  100% { background-position: 0 0; }
}
`

export default function PlaceholderInput({ width = '100%', height = '48px', borderRadius = '8px', marginTop = '0px', marginBottom = '0px' }) {
  return (
    <>
      <style>{shimmerKeyframes}</style>
      <div style={{ height: marginTop }}></div>
      <div
        style={{
          width: width,
          height: height,
          borderRadius: borderRadius,
          background: 'linear-gradient(90deg, #EDEDED 30%, #DCDCDC 50%, #EDEDED 70%)',
          backgroundSize: '400%',
          animation: 'shimmer 1.5s infinite linear',
        }}
      ></div>
      <div style={{ height: marginBottom }}></div>
    </>
  )
}
